import { render, staticRenderFns } from "./finder.vue?vue&type=template&id=497b9322&scoped=true"
import script from "./finder.vue?vue&type=script&lang=js"
export * from "./finder.vue?vue&type=script&lang=js"
import style0 from "./finder.vue?vue&type=style&index=0&id=497b9322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497b9322",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Dropdown: require('/var/www/html/jayuvillage/components/dropdown.vue').default})
